import style from "./TablePagination.module.css";
import { useTranslation } from "react-i18next";

import { padZero } from "@/utils/helpers";
import Icon from "@/ui/icon/Icon";

function TablePagination({ table, leftSection }) {
	const { t } = useTranslation();
	const currentPageInfo = {
		from: Math.min(
			table.getState().pagination.pageIndex *
				table.getState().pagination.pageSize +
				1,
			table.getRowCount()
		),
		to: Math.min(
			(table.getState().pagination.pageIndex + 1) *
				table.getState().pagination.pageSize,
			table.getRowCount()
		),
	};

	return (
		<div className={style.pagination}>
			{leftSection}
			<span className={style.pageIndex}>
				{t("common:pagination.range", {
					from: padZero(currentPageInfo.from),
					to: padZero(currentPageInfo.to),
					total: padZero(table.getRowCount()),
				})}
			</span>
			<button
				className={style.btn}
				onClick={() => table.previousPage()}
				disabled={!table.getCanPreviousPage()}
			>
				<Icon icon="fa-arrow-left" />
			</button>
			<button
				className={style.btn}
				onClick={() => table.nextPage()}
				disabled={!table.getCanNextPage()}
			>
				<Icon icon="fa-arrow-right" />
			</button>
		</div>
	);
}

export default TablePagination;
